import * as React from "react";
import { Formik, Form } from "formik";

import SaveButton from "../../../components/save-button";
import Title from "../../../components/title";
import { IWorkout } from "../../../resources/user/types";

import styles from "./note.module.css";

interface IProps {
  onSubmit: (values: string) => void;
  workout: IWorkout;
}

export default function Note({ onSubmit, workout }: IProps) {
  const [isButtonShown, setIsButtonShown] = React.useState(false);

  const onClickCancel = (setFieldValue: any) => () => {
    setFieldValue("note", workout.note);
    setIsButtonShown(false);
  };

  const onSave = () => {
    setIsButtonShown(true);
  };

  async function onSae(values: any) {
    await onSubmit(values.note);
    setIsButtonShown(false);
  }

  return (
    <Formik
      validateOnChange
      initialValues={{
        note: workout.note
      }}
      onSubmit={onSae}
    >
      {({ values, setFieldValue }) => (
        <Form className={styles.exercise}>
          <div className={styles.head}>
            <Title>Notes</Title>
            {isButtonShown && (
              <div className={styles.blockCancelSave}>
                <SaveButton
                  className={styles.cancel}
                  onClick={onClickCancel(setFieldValue)}
                >
                  cancel
                </SaveButton>
                <SaveButton className={styles.save} type="submit">
                  save
                </SaveButton>
              </div>
            )}
          </div>
          <div className={styles.noteContainer} onClick={onSave}>
            <textarea
              className={styles.notes}
              name="note"
              value={values.note}
              onChange={e => setFieldValue("note", e.target.value)}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
